<template>
    <div>
        <mdb-row>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col class="text-center">


                <mdb-row>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                </mdb-row>
                <br />
                <br />

                <mdb-datatable v-bind:data="data" v-bind:searching="false" striped bordered hover class="w-75" />



            </mdb-col>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col col="1"></mdb-col>


        </mdb-row>

        <mdb-row>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
        </mdb-row>

        <button type="button" class="bottomLeftButton" id="bottomLeftButton" onClick="document.getElementById('bottomLeftBanner').remove();this.remove();">x</button>
        <div class="bottomLeftBanner" id="bottomLeftBanner"><square-banner></square-banner></div>

        <button type="button" class="bottomRightButton" id="bottomRightButton" onClick="document.getElementById('bottomRightBanner').remove();this.remove();">x</button>
        <div class="bottomRightBanner" id="bottomRightBanner"><square-banner></square-banner></div>


    </div>
</template>

<script>
    import { mdbRow, mdbCol, Btn, mdbDatatable } from 'mdbvue';

    export default {
        components: { mdbRow, mdbCol, Btn, mdbDatatable },
        data() {
            return {
                recaptchav2SiteKey: this.$store.state.recaptchav2SiteKey,
                recaptchav3SiteKey: this.$store.state.recaptchav3SiteKey,
                errorList: null,
                successList: null,
                reference: null,
                subject: null,
                message: null,
                data: {
                    columns: [
                        {
                            label: 'Success',
                            field: 'success',
                            sort: 'asc'
                        },
                        {
                            label: 'Date',
                            field: 'dateTime',
                            sort: 'asc'
                        }
                    ],
                    rows: [

                    ]
                },










            }
        },
        sockets: {

        },
        methods: {
            test: function () {
            }

        },
        mounted() {

            this.$store.commit('isLoading', true);
            this.data.rows.length = 0;
            var data = this.$store.state.loginHistory;

            for (var i = 0; i < Object.keys(data).length; i++) {


                this.data.rows.push({ success: data[i].Success, dateTime: this.moment(data[i].DateTime).format('YYYY-MM-DD - hh:mm:ss A') });

            }

            this.$store.commit('isLoading', false);
        }
    }


</script>